/**
 * Check if an element has horizontal or vertical overflow.
 * @param {HTMLElement | { current: HTMLElement }} item - The React ref or DOM element to check.
 * @param {String} [axis='x'] - The direction to check for overflow: 'x' (horizontal) or 'y' (vertical).
 * @returns {Boolean|undefined} - Returns true if the element has overflow in the specified direction, falsy otherwise.
 */
export const checkOverflow = (item, axis = 'x') => {
    const el = item?.current || item;
    if (el) {
        switch (axis) {
            case 'x': // 𝘩𝘰𝘳𝘪𝘻𝘰𝘯𝘵𝘢𝘭
                return el.offsetWidth < el.scrollWidth;
            case 'y': // 𝘷𝘦𝘳𝘵𝘪𝘤𝘢𝘭
                return el.offsetHeight < el.scrollHeight;
        }
    }
};
